import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Content from "../../../Components/Dashboard/Content/Content";
import { getCompanyByIP } from "../../../Service/admin.service";
import { useEffect, useState } from "react";

/**
 * Inline SVG components (local, no external requests)
 * You can replace these SVGs with any other SVG markup if you want different icons.
 */

const IconLogin = ({ className = "step-svg" }) => (
    <svg
        className={className}
        width="140"
        height="140"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.2" />
        <path d="M8 11h6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        <path d="M11 8v6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
);

const IconProfile = ({ className = "step-svg" }) => (
    <svg
        className={className}
        width="140"
        height="140"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <circle cx="12" cy="8" r="3" stroke="currentColor" strokeWidth="1.2" />
        <path d="M4 20c1.5-4 6-6 8-6s6.5 2 8 6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
);

const IconApiKey = ({ className = "step-svg" }) => (
    <svg
        className={className}
        width="140"
        height="140"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path d="M3 12h6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        <path d="M15 6h6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        <rect x="9" y="4" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.2" />
        <rect x="9" y="14" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.2" />
    </svg>
);

const IconIP = ({ className = "step-svg" }) => (
    <svg
        className={className}
        width="140"
        height="140"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <rect x="2.5" y="5" width="19" height="14" rx="1.2" stroke="currentColor" strokeWidth="1.2" />
        <path d="M7 9h1v6H7zM10 9h1v6h-1zM13 9h1v6h-1zM16 9h1v6h-1z" fill="currentColor" />
    </svg>
);

const IconSecurity = ({ className = "step-svg" }) => (
    <svg
        className={className}
        width="140"
        height="140"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path d="M12 3l7 3v5c0 5-3.5 9.5-7 11-3.5-1.5-7-6-7-11V6l7-3z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="11" r="2" stroke="currentColor" strokeWidth="1.2" />
    </svg>
);

const CoinSwitch = () => {
    const [ipAddress, setIpAddress] = useState("");

    useEffect(() => {
        fetchIP();
    }, []);

     const fetchIP = async () => {
        try {
            const res = await getCompanyByIP();
            if (res?.status) {
                setIpAddress(res.data?.ip || "");
            }
        } catch (e) {
            console.error("IP Fetch Error:", e);
        }
    };
    

    const steps = [
        {
            title: "Step 1: Login",
            desc: (
                <>
                    Go to{" "}
                    <a
                        href="https://coinswitch.co/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://coinswitch.co/
                    </a>{" "}
                    and log into your account.
                </>
            ),
            // svg component instead of external image
            icon: <IconLogin />,
        },
        {
            title: "Step 2: Open Profile & Select API Key",
            desc: (
                <>
                    Click on your profile icon at the top-right corner and choose{" "}
                    <strong>“API Management”</strong> or <strong>“API Key”</strong> option.
                </>
            ),
            icon: <IconProfile />,
        },
        {
            title: "Step 3: Create New API Key",
            desc: (
                <>
                    Click on the <strong>“Create API Key”</strong> button and follow the
                    on-screen instructions.
                </>
            ),
            icon: <IconApiKey />,
        },
        {
            title: "Step 4: Add IP Whitelist",
            desc: (
                <>
                    Add the following IP in your <strong>IP Whitelist</strong>:
                    <div className="alert alert-info mt-3 mb-0 text-center">
                        <strong>
                            {ipAddress ? ipAddress : "Loading..."}
                        </strong>
                    </div>
                </>
            ),
            icon: <IconIP />,
        },
        {
            title: "Step 5: Save Keys Securely",
            desc: (
                <>
                    Copy your <strong>API Key</strong> and <strong>Secret Key</strong> and
                    store them safely — you’ll need these for your integration.
                </>
            ),
            icon: <IconSecurity />,
        },
    ];

    return (
        <Content
            Page_title="CoinSwitch API Key Setup"
            button_title="Back"
            route="/subadmin/apicreateinfo"
        >
            <div className="container py-4">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className="card shadow-sm mb-4 border-0 rounded-3 step-card"
                    >
                        <div className="card-body d-flex flex-column flex-md-row align-items-center gap-3">
                            <div style={{ flex: "0 0 160px", textAlign: "center" }}>
                                {/* render inline svg icon */}
                                <div className="icon-wrapper d-inline-block p-2 rounded-3">
                                    {step.icon}
                                </div>
                            </div>

                            <div style={{ flex: "1 1 auto" }}>
                                <h5 className="fw-bold mb-2">{step.title}</h5>
                                <p className="mb-0">{step.desc}</p>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Final Button */}
                <div className="text-center mt-4">
                    <a
                        href="https://coinswitch.co/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary px-4 py-2 fw-semibold"
                    >
                        Go to CoinSwitch
                    </a>
                </div>
            </div>

            <style>{`
        .step-svg { 
          width: 100px; 
          height: 100px; 
          color: #0d6efd; /* matches bootstrap primary */
          display: block;
          margin: 0 auto;
        }
        .icon-wrapper { 
          width: 120px; 
          height: 120px; 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          background: rgba(13,110,253,0.06);
        }
        .step-card {
          transition: transform 0.18s ease, box-shadow 0.18s ease;
        }
        .step-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 18px rgba(0,0,0,0.08);
        }

        /* small responsive tweaks */
        @media (max-width: 767px) {
          .card-body { flex-direction: column !important; text-align: center; }
        }
      `}</style>
        </Content>
    );
};

export default CoinSwitch;
